var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height black",attrs:{"fluid":""}},[_c('div',{ref:"h5p-preview",staticClass:"h5p-container",staticStyle:{"width":"99%","height":"99%","box-sizing":"content-box"}})])}
var staticRenderFns = []

export { render, staticRenderFns }